import React, { Component } from "react";
import ReactMapGL, { FlyToInterpolator, Marker } from "react-map-gl";
import styled from "styled-components";
import { connect } from "react-redux";

import LocationIcon from "./icons/Mapmarker";
import PlaceInfo from "./MapPopup";
import BeeswarmSVGOverlay from "./MapOverlay";

const TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

const LocationContainer = styled.div`
  display: flex;
  margin-left: ${props => (props.chosen ? "-280px" : "0")};
`;

const mapStyles = {
  light: "mapbox://styles/pixonal/cjvxphgir07f81co8pkn3kg8g",
  dark: "mapbox://styles/pixonal/cjvhw6h7p0xi31cs0py26cge7"
};

class Map extends Component {
  state = {
    chosenLocation: "",
    viewport: {
      width: "100vw",
      height: "100vh",
      latitude: 25.00957,
      longitude: 55.125615,
      zoom: 10.2,
      minZoom: 10.2,
      maxZoom: 15
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.activeLocation &&
      this.props.activeLocation !== prevProps.activeLocation
    ) {
      this.setActiveLocation(this.props.activeLocation);
    }
  }

  componentWillUnmount() {
    this.props.changeMapView("MAP");
  }

  setActiveLocation = place => {
    const { lat, lng, name } = place;

    this.setState(state => {
      return {
        chosenLocation: name,
        viewport: {
          ...state.viewport,
          latitude: lat - 0.004,
          longitude: lng - 0.003,
          zoom: 15,
          transitionInterpolator: new FlyToInterpolator(),
          transitionDuration: 1000
        }
      };
    });
  };

  handlePopupClose = () => {
    this.props.onZoomClose();
    this.setState(prevState => {
      return {
        chosenLocation: "",
        popupInfo: null,
        viewport: {
          ...prevState.viewport,
          width: "100wh",
          height: "100vh",
          latitude: 25.00957,
          longitude: 55.125615,
          zoom: 10.2,
          transitionInterpolator: new FlyToInterpolator(),
          transitionDuration: 1800
        }
      };
    });
  };

  renderLocationMarker = (place, index) => {
    const { chosenLocation } = this.state;
    return (
      <Marker
        key={`marker-${index}`}
        longitude={place.lng}
        latitude={place.lat}
      >
        <LocationContainer chosen={chosenLocation === place.name}>
          {chosenLocation === place.name && (
            <PlaceInfo onClose={this.handlePopupClose} />
          )}
          <LocationIcon
            chosen={chosenLocation === place.name}
            onClick={() => this.props.onMapClick(place)}
          />
        </LocationContainer>
      </Marker>
    );
  };

  updateViewport = viewport => {
    this.setState({ viewport });
  };

  render() {
    const {
      markLocations,

      theme,
      children,
      dragPan,
      view,
      zoomed,
      onMapClick,
      serviceKPIsData,
      counts,
      totalCount
    } = this.props;
    const { viewport } = this.state;
    return (
      <ReactMapGL
        {...viewport}
        attributionControl={false}
        mapStyle={theme === "dark" ? mapStyles.dark : mapStyles.light}
        onViewportChange={this.updateViewport}
        mapboxApiAccessToken={TOKEN}
        scrollZoom={view === "MAP"}
        dragRotate={false}
        dragPan={dragPan && view === "MAP"}
        doubleClickZoom={view === "MAP"}
        touchZoom={view === "MAP"}
        touchRotate={false}
      >
        {!zoomed && (
          <BeeswarmSVGOverlay
            serviceKPIsData={serviceKPIsData}
            locations={markLocations}
            view={view}
            onMapClick={onMapClick}
            counts={counts}
            totalCount={totalCount}
          />
        )}
        {view === "MAP" &&
          zoomed &&
          markLocations.map(this.renderLocationMarker)}
        {children}
      </ReactMapGL>
    );
  }
}

const mapStateToProps = state => ({
  theme: state.themes.theme,

  // Just for demo
  serviceKPIsData: state.services.data
});

export default connect(mapStateToProps)(Map);
